import React from 'react'
import UnderlinedText from '#src/components/UnderlinedText'
import classNames from 'classnames'
import { SellableSpecificationFragment } from '#src/generated/graphql'
import styles from './styles.css'

interface HighlightedSpecificationsProps {
  specifications: SellableSpecificationFragment[]
  itemsPerRow?: number
}

const HighlightedSpecifications: React.SFC<HighlightedSpecificationsProps> = ({
  specifications,
  itemsPerRow = 3
}) => {
  return (
    <div className={styles.specifications}>
      <div className={styles.attributes}>
        {specifications.slice(0, itemsPerRow * 2).map((spec, idx) => {
          return (
            <div
              className={classNames(styles.attribute, {
                [styles.spacedAttribute]: specifications.length > itemsPerRow
              })}
              style={{
                flexBasis: `${100 / itemsPerRow}%`
              }}
              key={idx}
            >
              <UnderlinedText thickness={2} underlineColor="#e6e6e6" className={styles.underline}>
                <div className={styles.attributeHeader}>{spec.name}</div>
              </UnderlinedText>

              <div
                className={styles.attributeValue}
                dangerouslySetInnerHTML={{
                  __html: spec.valueHtml
                }}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default HighlightedSpecifications
